// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3rBZ-","rowsWrapper":"style_rowsWrapper__1BQrQ","rowWrapper":"style_rowWrapper__2gvUA"};